import { Badge, Layout } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { devices } from '../../const/devices';
import { useIsTablet } from '../../hooks/useBreakpoint';
import Logo from '../Logo';
import LogoSmall from '../LogoSmall';
import NewStudentButton from '../NewStudentButton';
import UserMenu from '../UserMenu';
import UserSearch from '../UserSearch/UserSearch';

const { Header: AntdHeader } = Layout;

const StyledAntdHeader = styled(AntdHeader)`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	background: #ffffff;
	position: relative;
	box-shadow: 0px 2px 6px 0px #0000000d;
	grid-area: header;

	@media ${devices.laptop} {
		padding: 0 1rem;
	}
`;

const LeftSide = styled.div`
	display: flex;
	width: 100%;
`;

const StyledLogo = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding-right: 6rem;
	position: relative;

	@media ${devices.laptop} {
		padding-right: 1rem;
	}

	a {
		img {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
`;

const StyledSearchWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 15px;
	width: 100%;
	max-width: 550px;
	padding-right: 1rem;

	@media ${devices.tablet} {
		padding-right: 0;
	}
`;

const BetaFlag = styled(Badge)`
	position: absolute;
	top: 0;
	left: 20px;
	z-index: 1;
	display: none;

	${devices.tablet} {
		display: block;
	}
`;

interface Props {
	isLoginFlow?: boolean;
}

export const Header: React.FC<Props> = ({ isLoginFlow }) => {
	const isTablet = useIsTablet();

	const renderSearchInput = () => {
		if (isLoginFlow) {
			return null;
		}

		if (isTablet) {
			return null;
		}

		return (
			<StyledSearchWrapper>
				<UserSearch />
				{!isTablet && <NewStudentButton />}
			</StyledSearchWrapper>
		);
	};

	return (
		<StyledAntdHeader>
			<LeftSide>
				<StyledLogo>
					<Link to="/">{isTablet ? <LogoSmall /> : <Logo />}</Link>
					<BetaFlag className="site-badge-count-109" count="BETA" style={{ backgroundColor: '#002766' }} />
				</StyledLogo>
				{renderSearchInput()}
			</LeftSide>
			{!isTablet && <UserMenu />}
		</StyledAntdHeader>
	);
};
